import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ContentBox, ContentPage, DescriptionList, NoResults } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import PaymentScheduleTab from "@components/PaymentScheduleTab";
import ProjectHoursTab from "@components/ProjectHoursTab";
import { DocumentNumber, usePageHeader } from "@components/ow";
import {
  ContractDetailSkeleton,
  DataTab,
  DetailTabs,
  PatternSection,
  RemunerationSection,
  ServicesSection,
  TermSection,
  detailTitle,
} from "../../Common/ContractDetail";

export default function ContractDetailsEmployee() {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const contractService = useService("contracts");

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const defaultTab = searchParams.get("tab") || "dados";
  const [activeTab, setActiveTab] = useState(defaultTab);

  const found = !!(data && data.id);
  const companyName = data.company?.name || "Contrato";
  usePageHeader({
    title: found ? detailTitle(data.company?.name, data) : "Contrato",
    breadcrumb: [
      { page: "Meus contratos", route: "/e/contracts" },
      { page: found ? companyName : "Contrato", route: `/e/contracts/${params.id}` },
    ],
  });

  useEffect(() => {
    fetchContract();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchContract() {
    try {
      setLoading(true);
      const result = await contractService.get(params.id);
      if (result.data) {
        setData(result.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <ContractDetailSkeleton />;

  if (!found) {
    return (
      <ContentPage>
        <ContentBox>
          <NoResults
            notResultText="Contrato não encontrado"
            includeText="Voltar para Meus contratos"
            includeAction={() => navigate("/e/contracts")}
          />
        </ContentBox>
      </ContentPage>
    );
  }

  const user = JSON.parse(localStorage.getItem("user_ow") || "{}");
  const noBank = !user.bankData?.pix_key && !user.bankData?.bank_code;

  const tabs = [
    {
      value: "dados",
      label: "Dados",
      content: (
        <DataTab
          contract={data}
          left={
            <>
              <DescriptionList
                $title="Empresa"
                $items={[
                  { label: "Nome", value: data.company?.name },
                  { label: "CNPJ", value: data.company?.cnpj ? <DocumentNumber value={data.company.cnpj} showKind={false} /> : null },
                ]}
              />
              <RemunerationSection contract={data} />
            </>
          }
          right={
            <>
              <TermSection contract={data} />
              <PatternSection contract={data} title="Prazos" />
              <ServicesSection serviceCodes={data.service_codes} />
            </>
          }
        />
      ),
    },
    {
      value: "cronograma",
      label: "Pagamentos e notas",
      content: <PaymentScheduleTab contractId={parseInt(params.id)} contract={data} isAdmin={false} noBank={noBank} />,
    },
  ];

  if (data.project_id) {
    tabs.push({
      value: "horas",
      label: "Minhas horas",
      content: (
        <ProjectHoursTab
          projectId={data.project_id}
          userId={user.id}
          isAdmin={false}
          hourMarkingModel={data.hour_marking_model}
          hourTrackingMode={data.hour_tracking_mode}
          contract={data}
        />
      ),
    });
  }

  return (
    <ContentPage>
      <ContentBox>
        <DetailTabs tabs={tabs} value={activeTab} onChange={setActiveTab} />
      </ContentBox>
    </ContentPage>
  );
}
